/**
 * Source unique de vérité pour le token d'authentification.
 *
 * Le projet stocke le token sous DEUX clés selon l'endroit où l'on s'est
 * connecté :
 *   - 'adminToken' → posé par admin/AdminLogin.js (back-office)
 *   - 'token'      → posé par services/authService.js (portail utilisateur)
 *
 * On lit les deux, l'admin en premier. Oublier 'adminToken' reviendrait à
 * n'envoyer aucun token depuis le back-office, donc à casser toute
 * l'administration d'un coup.
 */
export const getAuthToken = () =>
  localStorage.getItem('adminToken') || localStorage.getItem('token') || null;

/** En-têtes prêts à l'emploi pour les appels `fetch()` restants. */
export const authHeaders = (extra = {}) => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
};

export const clearAuthToken = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
